const ru = {
    appName: "NS Portal"
}

export default ru;
